import type { CameraSettings, ColorSample, EncounterRecord, GeoState, TrackedFace } from '../../types';
import { paletteName } from '../color-analysis/colorAnalysis';

const alpha = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

export function createEncounterId(date = new Date()) {
  const pad = (value: number) => value.toString().padStart(2, '0');
  const stamp = `${date.getFullYear().toString().slice(-2)}${pad(date.getMonth() + 1)}${pad(date.getDate())}-${pad(date.getHours())}${pad(date.getMinutes())}${pad(date.getSeconds())}`;
  const suffix = Array.from({ length: 4 }, () => alpha[Math.floor(Math.random() * alpha.length)]).join('');
  return `G-${stamp}-${suffix}`;
}

export function buildEncounter(photoBlob: Blob, palette: ColorSample[], location: GeoState, faces: TrackedFace[], settings: CameraSettings, module: { id: string; version: string }): EncounterRecord {
  const people = faces.length ? faces.map((face) => ({ label: face.label, identityId: face.identityId })) : [{ label: 'LUN' }, { label: settings.guestName }];
  return {
    id: createEncounterId(),
    createdAt: new Date().toISOString(),
    module,
    people,
    location: { latitude: location.latitude ?? null, longitude: location.longitude ?? null, accuracy: location.accuracy ?? null },
    photoBlob,
    palette,
    paletteName: paletteName(palette),
    settingsSnapshot: { ...settings },
  };
}
